import { defineAdapter } from "@repo/adapter-core";
import { parseGenericListingHtml } from "../shared/generic-parser.ts";
import {
  PROPERTY_COM_AU_DEFAULT_CONFIG,
  PropertyComAuAdapterConfigSchema,
  resolvePropertyComAuConfig,
} from "./config.ts";
import { PROPERTY_COM_AU_ADAPTER_META } from "./meta.ts";
import { buildSearchUrl } from "./runtime.ts";

export * from "./config.ts";
export * from "./meta.ts";
export * from "./runtime.ts";

export const PROPERTY_COM_AU_ADAPTER = defineAdapter({
  meta: PROPERTY_COM_AU_ADAPTER_META,
  defaultConfig: PROPERTY_COM_AU_DEFAULT_CONFIG,
  resolvedConfigSchema: PropertyComAuAdapterConfigSchema,
  resolveConfig: resolvePropertyComAuConfig,
  buildSearchUrl,
  // Search URLs can list sold, for-sale or rental listings: each is its own discovery lane.
  listingTypes: ["buy", "sold", "rent"],
  // property.com.au sits behind the same Akamai stack as REA + Domain
  // (returns 429 to Firecrawl + Zyte). Search pages go to Bright Data first; the
  // existing REA Web Unlocker zone is host-agnostic. The Scraping
  // Browser zone is also opted in because Web Unlocker has returned
  // `<head>`-only stubs on this host (see docs/scraper-routing.md).
  brightdataDiscoveryFirst: true,
  brightdataBrowserZoneEnvVar: "BRIGHTDATA_SPA_BROWSER_WSS_URL",
  parseDetailHtml: parseGenericListingHtml,
});
